import { useQuery } from '@tanstack/react-query';
import { countriesService } from '../api/countries';
import type { Country } from '../types';

export function useCountries() {
  return useQuery({
    queryKey: ['countries'],
    queryFn: () => countriesService.getAllCountries(),
    staleTime: 10 * 60 * 1000, // 10 minutes - countries don't change often
  });
}

export function useCountriesMap() {
  const { data: countries, ...rest } = useCountries();

  // Create a map of isoCode2 -> Country for quick lookup
  const countriesMap = new Map<string, Country>();
  if (countries) {
    for (const country of countries) {
      countriesMap.set(country.isoCode2, country);
    }
  }

  return {
    ...rest,
    data: countries,
    countriesMap,
    getCountry: (isoCode2: string) => countriesMap.get(isoCode2),
    getCountryName: (isoCode2: string) => countriesMap.get(isoCode2)?.name ?? isoCode2,
    getCountryFlag: (isoCode2: string) => countriesMap.get(isoCode2)?.flagEmoji ?? '',
    getCountryDisplay: (isoCode2: string) => {
      const country = countriesMap.get(isoCode2);
      if (!country) return isoCode2;
      return country.flagEmoji ? `${country.flagEmoji} ${country.name}` : country.name;
    },
  };
}
